import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
declare function shopPage(): any;

@Component({
    selector: 'app-shop',
    templateUrl: './shop.component.html',
    styleUrls: ['./shop.component.css'],
    standalone: false
})
export class ShopComponent implements OnInit, OnDestroy {

  /**
   * 2026-10-24: `shop/:id` and `shop/:id/category/:id` reuse this component,
   * so an in-app link from /shop/car to /shop/nadlan (footer, home, search)
   * kept the car page's components - and their filters - on screen. The
   * template renders the page inside `@for (k of [pageKey]; track k)`, so a
   * new PATH builds it again. A query-only change (?filters=..., written on
   * every filter pick) keeps the same key and nothing is rebuilt.
   */
  pageKey = '';
  private sub?: Subscription;

  constructor(private router: Router) {
    this.pageKey = this.pathOf(this.router.url);
  }

  ngOnInit(): void {
    shopPage();
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        const key = this.pathOf(e.urlAfterRedirects || e.url);
        if (key === this.pageKey) return;
        this.pageKey = key;
        setTimeout(() => shopPage());   // the legacy carousel init, for the new DOM
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private pathOf(url: string): string {
    return (url || '').split('#')[0].split('?')[0];
  }
}
